// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MethodologySection_section__Qhm\\+y {
  margin-top: calc(var(--space-xxl) * 2);
  padding-bottom: var(--space-xxl);
}

.MethodologySection_topBar__qVso1 {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin-bottom: var(--space-lg);
}

.MethodologySection_label__qpfzM {
  color: var(--color-text-subtle);
  font-size: var(--font-size-small);
}

.MethodologySection_layout__iwbRO {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-xl);
  align-items: start;
}

.MethodologySection_column__w0dAl {
  min-width: 0;
}

.MethodologySection_headline__7MyKn {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-weight-bold);
  line-height: 1.05;
  margin-bottom: var(--space-lg);
}

.MethodologySection_principles__qDs2p {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

.MethodologySection_principle__YPpPF {
  display: flex;
  flex-direction: column;
  gap: calc(var(--space-xs) * 0.8);
}

.MethodologySection_principleHeader__-Nsgl {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.MethodologySection_badge__RoUe8 {
  flex: 0 0 auto;
  min-width: 2.2rem;
  color: #4da3ff;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
}

.MethodologySection_principleTitle__07i\\+r {
  font-size: var(--font-size-medium);
  margin-bottom: 0;
}

.MethodologySection_principleDescription__1b5v8 {
  font-size: var(--font-size-small);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
  padding-left: calc(2.2rem + var(--space-sm));
}

.MethodologySection_actionRow__9Scb0 {
  margin-top: var(--space-xl);
}

@media (max-width: 1024px) {
  .MethodologySection_layout__iwbRO {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .MethodologySection_topBar__qVso1 {
    align-items: flex-start;
  }

  .MethodologySection_principle__YPpPF {
    gap: 0.35rem;
  }

  .MethodologySection_principleHeader__-Nsgl {
    gap: 0.5rem;
  }

  .MethodologySection_badge__RoUe8 {
    min-width: 0;
  }

  .MethodologySection_principleDescription__1b5v8 {
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MethodologySection.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".section {\n  margin-top: calc(var(--space-xxl) * 2);\n  padding-bottom: var(--space-xxl);\n}\n\n.topBar {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  margin-bottom: var(--space-lg);\n}\n\n.label {\n  color: var(--color-text-subtle);\n  font-size: var(--font-size-small);\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-xl);\n  align-items: start;\n}\n\n.column {\n  min-width: 0;\n}\n\n.headline {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-weight-bold);\n  line-height: 1.05;\n  margin-bottom: var(--space-lg);\n}\n\n.principles {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n.principle {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--space-xs) * 0.8);\n}\n\n.principleHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.badge {\n  flex: 0 0 auto;\n  min-width: 2.2rem;\n  color: #4da3ff;\n  font-size: var(--font-size-small);\n  font-weight: var(--font-weight-bold);\n}\n\n.principleTitle {\n  font-size: var(--font-size-medium);\n  margin-bottom: 0;\n}\n\n.principleDescription {\n  font-size: var(--font-size-small);\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.78);\n  padding-left: calc(2.2rem + var(--space-sm));\n}\n\n.actionRow {\n  margin-top: var(--space-xl);\n}\n\n@media (max-width: 1024px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .topBar {\n    align-items: flex-start;\n  }\n\n  .principle {\n    gap: 0.35rem;\n  }\n\n  .principleHeader {\n    gap: 0.5rem;\n  }\n\n  .badge {\n    min-width: 0;\n  }\n\n  .principleDescription {\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `MethodologySection_section__Qhm+y`,
	"topBar": `MethodologySection_topBar__qVso1`,
	"label": `MethodologySection_label__qpfzM`,
	"layout": `MethodologySection_layout__iwbRO`,
	"column": `MethodologySection_column__w0dAl`,
	"headline": `MethodologySection_headline__7MyKn`,
	"principles": `MethodologySection_principles__qDs2p`,
	"principle": `MethodologySection_principle__YPpPF`,
	"principleHeader": `MethodologySection_principleHeader__-Nsgl`,
	"badge": `MethodologySection_badge__RoUe8`,
	"principleTitle": `MethodologySection_principleTitle__07i+r`,
	"principleDescription": `MethodologySection_principleDescription__1b5v8`,
	"actionRow": `MethodologySection_actionRow__9Scb0`
};
export default ___CSS_LOADER_EXPORT___;
